import {createContext, Dispatch, SetStateAction, useContext, Context} from 'react';

export type SelectedOptionType = {
    name: string,
    value: string
}

export type VariantEdgeType = {
    "node": {
        availableForSale: boolean,
        compareAtPrice: {
            amount: string,
            currencyCode: string,
        },
        currentlyNotInStock: boolean,
        id: string,
        image: {
            id: string,
            url: string
        },
        priceV2: {
            amount: string,
            currencyCode: string,
        },
        selectedOptions: SelectedOptionType[]
        sku: string,
        title: string
    }
}

export type VariantType = {
    edges: VariantEdgeType[]
}

export type ProductType = {
    options?: any;
    images: string[],
    title: string,
    variants: VariantType,
}
export type AppDataType = {
    step?: number | undefined,
    seat?: string | undefined,
    color?: string | undefined,
    selectedId?: string | undefined,
    year?: number | undefined,
    make?: string | undefined,
    model?: string | undefined,
    check?: { compatibility: string, compatibility_custom: string, availability: object } | undefined,
    product?: ProductType | undefined,
    originalProduct?: ProductType | undefined
    addons?: string | undefined
    trim?: string | undefined
    cab?: string | undefined
    has_trims?: boolean | undefined
    has_cabs?: boolean | undefined
    with_bonus?: boolean | undefined
    trims?: object | undefined | null
} | null

type AppDataContextType = {
    currentAppData: AppDataType | null
    setCurrentAppData: Dispatch<SetStateAction<AppDataType | null>>
}

export const AppDataContext = createContext<AppDataContextType | undefined>(undefined)

// ...

export function useContextThrowUndefined<T>(
    context: Context<T | undefined>
): T {
    const value = useContext(context);
    if (value === undefined) {
        const name = context.displayName ?? "Unnamed";
        throw new Error(
            `${name} context consumer was used outside of a context provider.
To fix this, make sure the provider is always higher up the component tree than the consumer.`
        );
    }
    return value;
}

export const useAppData = () => useContextThrowUndefined(AppDataContext);